import(/* webpackMode: "eager", webpackExports: ["LoginShell"] */ "/vercel/path0/apps/web/src/app/(auth)/login/login-shell.tsx");
